module.exports = __webpack_public_path__ + "static/img/logo-web-i3m.e289134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-web-i3m.png
// module id = sVUY
// module chunks = 1